import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import util from 'util';
import constClass from '../../Constants/Constants';
import Common from '../Common/common';
import CommonBooking from '../Common/common_booking';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

const BookingInput = (props) => {
  //この辺りにDB入力用の変数を作りまくる
  const [bookReceiptNum, setBookReceiptNum] = useState(null);
  const [bookArea, setBookArea] = useState(null);
  const [bookShop, setBookShop] = useState(null);
  const [bookData, setBookData] = useState(null);
  const [bookCategory, setBookCategory] = useState(null);
  const [bookTime, setBookTime] = useState(null);
  const [bookStaff, setBookStaff] = useState(null);
  const [bookCardId, setBookCardId] = useState(null);
  const [bookName, setBookName] = useState(null);
  const [bookKana, setBookKana] = useState(null);
  const [bookAddressNumber, setBookAddressNumber] = useState(null);
  const [bookAddress1, setBookAddress1] = useState(null);
  const [bookAddress2, setBookAddress2] = useState(null);
  const [bookAddress3, setBookAddress3] = useState(null);
  const [bookPhone, setBookPhone] = useState(null);
  const [bookMobilePhone, setBookMobilePhone] = useState(null);
  const [bookBirthdayY, setBookBirthdayY] = useState(null);
  const [bookBirthdayM, setBookBirthdayM] = useState(null);
  const [bookBirthdayD, setBookBirthdayD] = useState(null);
  const [bookGender, setBookGender] = useState(null);
  const [bookTalk, setBookTalk] = useState(null);
  const [bookTalktext, setBookTalktext] = useState(null);
  const [bookConectMeans, setBookConectMeans] = useState(null);
  const [bookCustomerBeforeTime, setCustomerBeforeTime] = useState(null);
  const [bookCustomerAfterTime, setCustomerAfterTime] = useState(null);

  const [arealist, setArealist] = useState(null);
  const [shoplist, setShoplist] = useState(null);
  const [talklist, setTalklist] = useState(null);
  const [bookDateList, setBookDateList] = useState(null);
  const [categoryMaster, setCategoryMaster] = useState(null);
  const [bookTimeList, setBookTimeList] = useState(null);
  const [remarks, setRemarks] = useState(null);

  //DBに登録するための時間帯
  const [bookStartTime, setbookStartTime] = useState(null);
  const [bookEndTime, setbookEndTime] = useState(null);

  const [bookSetId, setBookSetId] = useState(null);

  const [booking, setbooking] = useState(null);
  const [customer, setcustomer] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  //book_idを取得
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const bookId = queryParams.get('bk');

  // エリア情報取得
  const getSelectArea = useCallback(async () => {
    const result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/area/search`, { site_id: props.siteId, operator: "and", where: [{ site_id: props.siteId }] })).data;
    setArealist(result)
  }, [props.siteId]);
  // 相談カテゴリー情報取得
  const getSelectTalk = useCallback(async () => {
    const result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/talk_category/search`, { site_id: props.siteId, operator: "and", where: [{ site_id: props.siteId }] })).data;
    setTalklist(result)
  }, [props.siteId]);

  const refreshBook = useCallback(async () => {
    //値を初期化する
    reset();

    getSelectArea();
    getSelectTalk();


    const jwt = localStorage.getItem('jwt');

    const resultShop = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shop/search`, { site_id: props.siteId, operator: "and", where: [{ site_id: props.siteId }] }, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    setShoplist(resultShop)

    //カレンダー情報取得
    const calendarPromise = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/calendar/listdate/${props.siteId}`);
    const monthSetting = Number.parseInt(props.settings?.BOOKING_DATE_LIMIT_MONTH, 10);
    const month = Number.isFinite(monthSetting) ? monthSetting : 1;
    const bookDateL = (await calendarPromise).data.filter(x => moment(x.book_date).isBefore(moment().add(month, "month").subtract(1, "day")));//翌月の1日前先まで予約可能
    setBookDateList(bookDateL);

    //カテゴリ情報取得（site_idに一致する全カテゴリ）
    const categoryPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/category/${props.siteId}`);
    const categorylist = (await categoryPromise).data;
    setCategoryMaster(categorylist)

    //site_idと本日以降の二つの条件で絞り込み
    const time = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/calendar/search/time/${props.siteId}`);
    setBookTimeList(time.data);

    //詳細画面から来た場合にあらかじめ値を入れて置く
    if (bookId) {
      var params = {
        "site_id": props.siteId,
        "book_id": Number(bookId),
      }
      //予約内容取得
      const jwt = localStorage.getItem('jwt');
      const booking = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/booking/search_detail_one/`,
        params,
        { headers: { Authorization: `Bearer ${jwt}` } }
      );
      const book = await booking.data;
      setBookReceiptNum(book.receipt_num)
      setbooking(book)

      //顧客情報取得
      const params_customer = {
        site_id: props.siteId,
        operator: "and",
        where: [
          { site_id: props.siteId },
        ]
      }
      const cust = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/search/`, params_customer, { headers: { Authorization: `Bearer ${jwt}` } });
      const customer = cust.data.filter(d => d.customer_id === book.customer_id)[0]
      setcustomer(customer)

      setBookArea(resultShop.filter(shop => shop.shop_id === book.t_booking_detail.shop_id)[0].area_id)
      setBookShop(book.t_booking_detail.shop_id)
      // book.book_dateがシステム日付前なら予約日を空にする
      if (moment(book.book_date).isBefore(moment(), 'day')) {
        setBookData('');
        setBookTime('');
      } else {
        setBookData(book.book_date);
        setBookTime(book.t_booking_detail.book_set_id);
      }
      setBookCategory(book.t_booking_detail.category_id);
      setBookStaff(book.t_booking_detail.staff_name);
      setBookCardId(customer.card_id);
      setBookName(book.customer_name);
      setBookKana(book.customer_kana);
      setBookAddressNumber(customer.customer_address_number);
      setBookAddress1(customer.customer_address1);
      setBookAddress2(customer.customer_address2);
      setBookAddress3(customer.customer_address3);
      setBookPhone(customer.customer_phone);
      setBookMobilePhone(customer.customer_mobilephone);
      setBookBirthdayY(customer.birthdayy);
      setBookBirthdayM(customer.birthdaym);
      setBookBirthdayD(customer.birthdayd);
      setBookGender(customer.customer_gender);
      setBookTalk(book.t_booking_detail.talk_id);
      setBookTalktext(book.t_booking_detail.talktext);
      setBookConectMeans(book.t_booking_detail.connect_means);
      setCustomerBeforeTime(book.t_booking_detail.customer_before_time);
      setCustomerAfterTime(book.t_booking_detail.customer_after_time);
      setbookStartTime(book.t_booking_detail.start_time);
      setbookEndTime(book.t_booking_detail.end_time);
      setBookSetId(book.t_booking_detail.book_set_id);
    }
  }, [bookId, getSelectArea, getSelectTalk, props.settings?.BOOKING_DATE_LIMIT_MONTH, props.siteId])

  const reset = () => {
    setBookArea('');
    setBookShop('');
    setBookData('');
    setBookCategory('');
    setBookTime('');
    setBookStaff('');
    setBookCardId(null);
    setBookName(null);
    setBookKana(null);
    setBookAddressNumber(null);
    setBookAddress1(null);
    setBookAddress2(null);
    setBookAddress3(null);
    setBookPhone(null);
    setBookMobilePhone(null);
    setBookBirthdayY(null);
    setBookBirthdayM(null);
    setBookBirthdayD(null);
    setBookGender(null);
    setBookTalk(null);
    setBookTalktext(null);
    setBookConectMeans(null);
    setCustomerBeforeTime(null);
    setCustomerAfterTime(null);
    setbookStartTime(null);
    setbookEndTime(null);
    setBookSetId(null);
  }

  const setPrefectures = () => {
    const prefectures = [
      { value: "", label: "- 都道府県 -" },
      { value: "北海道", label: "北海道" },
      { value: "青森県", label: "青森県" },
      { value: "岩手県", label: "岩手県" },
      { value: "宮城県", label: "宮城県" },
      { value: "秋田県", label: "秋田県" },
      { value: "山形県", label: "山形県" },
      { value: "福島県", label: "福島県" },
      { value: "茨城県", label: "茨城県" },
      { value: "栃木県", label: "栃木県" },
      { value: "群馬県", label: "群馬県" },
      { value: "埼玉県", label: "埼玉県" },
      { value: "千葉県", label: "千葉県" },
      { value: "東京都", label: "東京都" },
      { value: "神奈川県", label: "神奈川県" },
      { value: "新潟県", label: "新潟県" },
      { value: "富山県", label: "富山県" },
      { value: "石川県", label: "石川県" },
      { value: "福井県", label: "福井県" },
      { value: "山梨県", label: "山梨県" },
      { value: "長野県", label: "長野県" },
      { value: "岐阜県", label: "岐阜県" },
      { value: "静岡県", label: "静岡県" },
      { value: "愛知県", label: "愛知県" },
      { value: "三重県", label: "三重県" },
      { value: "滋賀県", label: "滋賀県" },
      { value: "京都府", label: "京都府" },
      { value: "大阪府", label: "大阪府" },
      { value: "兵庫県", label: "兵庫県" },
      { value: "奈良県", label: "奈良県" },
      { value: "和歌山県", label: "和歌山県" },
      { value: "鳥取県", label: "鳥取県" },
      { value: "島根県", label: "島根県" },
      { value: "岡山県", label: "岡山県" },
      { value: "広島県", label: "広島県" },
      { value: "山口県", label: "山口県" },
      { value: "徳島県", label: "徳島県" },
      { value: "香川県", label: "香川県" },
      { value: "愛媛県", label: "愛媛県" },
      { value: "高知県", label: "高知県" },
      { value: "福岡県", label: "福岡県" },
      { value: "佐賀県", label: "佐賀県" },
      { value: "長崎県", label: "長崎県" },
      { value: "熊本県", label: "熊本県" },
      { value: "大分県", label: "大分県" },
      { value: "宮崎県", label: "宮崎県" },
      { value: "鹿児島県", label: "鹿児島県" },
      { value: "沖縄県", label: "沖縄県" },
    ];

    const items = prefectures.map(pref => (
      <option value={pref.value} key={pref.value}>{pref.label}</option>
    ));
    return items;
  }

  // 月を取得
  const setMonth = () => {
    const items = [];
    items.push(<option value="" key={"-"}>- 月 -</option>)
    for (let i = 1; i <= 12; i++) {
      items.push(<option value={("00" + i).slice(-2)} key={i}>{i}</option>)
    }
    return items;
  }

  // 日にちを取得
  const setDay = (value) => {
    const items = [];
    const year = value.slice(0, 4);
    const month = value.slice(5, 7);
    items.push(<option value="" key={"-"}>- 日 -</option>)
    for (let i = 1; i <= 31; i++) {
      if (!year || !Number(month) || (new Date(year + '/' + month + '/' + ("00" + i).slice(-2)).getDate() === i)) {
        items.push(<option value={("00" + i).slice(-2)} key={i}>{i}</option>)
      }
    }
    return items;
  }

  const setTimeBefore = () => {
    const items = [];
    items.push(<option value="" key={"-"}>- 選択 -</option>)
    for (let i = 9; i <= 16; i++) {
      items.push(<option value={("00" + i).slice(-2)} key={i}>{i}</option>)
    }
    return items;
  }

  const setTimeAfter = () => {
    const items = [];
    items.push(<option value="" key={"-"}>- 選択 -</option>)
    if (bookCustomerBeforeTime) {
      for (let i = (Number(bookCustomerBeforeTime) + 1); i <= 17; i++) {
        items.push(<option value={("00" + i).slice(-2)} key={i}>{i}</option>)
      }
    } else {
      for (let i = 9; i <= 17; i++) {
        items.push(<option value={("00" + i).slice(-2)} key={i}>{i}</option>)
      }
    }
    return items;
  }

  const searchAddress = async (postal_code2, target) => {
    if (!postal_code2 || postal_code2 === "") return;
    var postal_code = Common.zenkaku2hankaku(postal_code2);//半角に変換
    postal_code = postal_code.length === 7 ? `${postal_code.substring(0, 3)}-${postal_code.substring(3)}` : postal_code;//ハイフンなしの場合はつける
    // API実行
    try {
      const res = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/address/${postal_code}`)).data;
      if (res) {
        var address1 = '';
        var address2 = '';
        var address3 = '';
        if (res.PrefecturesName) {
          address1 += res.PrefecturesName;
        }
        if (res.CityName) {
          address2 += res.CityName;
        }
        if (res.TownName) {
          address3 += res.TownName;
        }
        // 都道府県リストを取得
        const prefectures = setPrefectures().map(pref => pref.props.children);
        const selectedPrefecture = prefectures.find(pref => pref === address1);

        setBookAddress1(selectedPrefecture ? address1 : "");
        setBookAddress2(address2);
        setBookAddress3(address3);
      } else if (!res && postal_code.length === 8) {
        setBookAddress1("");
        setBookAddress2("");
        setBookAddress3("");
        alert('申し訳ありません。\n住所の取得ができませんでした。');
      } else {
        setBookAddress1("");
        setBookAddress2("");
        setBookAddress3("");
      }

    } catch (err) {
      console.error("エラー：", err);
      alert('住所検索に失敗しました');
    }
  }

  const changeselectarea = (data) => {
    setBookArea(data.target.value === '' ? '' : Number(data.target.value))
    //エリア変更に伴って選択している店舗をリセットする
    setBookShop('')
    setBookTime('')
  }
  const changeSelectShop = (data) => {
    setBookShop(data.target.value === '' ? '' : Number(data.target.value))
    setBookTime('')
  }
  const changeBookDate = (data) => {
    setBookData(data)
    setBookTime('')
  }
  const changeCategory = (data) => {
    setBookCategory(data)
    setBookTime('')
  }
  const changeDate = (data) => {
    const select = data
    setBookTime(select)

    //-選択-を選んだかの判定
    if (select === "") {
      setbookStartTime("");
      setbookEndTime("");
      setBookSetId("")
    } else {
      const selectedTime = (bookTimeList ?? []).find(d =>
        d.book_date === bookData && Number(bookShop) === Number(d.shop_id) && Number(d.category_id) === Number(bookCategory) && Number(d.book_set_id) === Number(select)
      )
      if (!selectedTime) {
        setbookStartTime("");
        setbookEndTime("");
        setBookSetId("")
        return;
      }
      //DB登録用
      setbookStartTime(selectedTime.start_time)
      setbookEndTime(selectedTime.end_time)
      setBookSetId(selectedTime.book_set_id)
      setRemarks(selectedTime.remarks)
    }
  }
  const changeCustomerStaff = (data) => {
    const select = data.target.value
    setBookStaff(select)
  }
  const changeCustomerCardId = (data) => {
    var select = data.target.value
    select = select.trim();
    select = select.replace(/\./g, '');
    if (!isNaN(select)) {
      setBookCardId(select)
    }
  }
  const changeCustomerName = (data) => {
    const select = data.target.value
    setBookName(select)
  }
  const changeCustomerKana = (data) => {
    const select = data.target.value
    setBookKana(select)
  }
  const changeAddresNumber = (data) => {
    var select = data.target.value
    select = select.trim();
    select = select.replace(/\./g, '');
    if (!isNaN(select)) {
      setBookAddressNumber(select)
    }
  }
  //都道府県変更
  const changeAddress1 = (data) => {
    const selectedValue = data.target.value;
    setBookAddress1(selectedValue)
  }
  // 市町村
  const changeAddress2 = (data) => {
    const selectedValue = data.target.value;
    setBookAddress2(selectedValue)
  }
  // 番地
  const changeAddress3 = (data) => {
    const selectedValue = data.target.value;
    setBookAddress3(selectedValue)
  }

  const changePhone = (data) => {
    var select = data.target.value
    select = select.trim();
    select = select.replace(/\./g, '');
    if (!isNaN(select)) {
      setBookPhone(select)
    }
  }
  const changeMobilephone = (data) => {
    var select = data.target.value
    select = select.trim();
    select = select.replace(/\./g, '');
    if (!isNaN(select)) {
      setBookMobilePhone(select)
    }
  }

  // 誕生日変更
  const changeDate_y = (data) => {
    var select = data.target.value
    select = select.trim();
    select = select.replace(/\./g, '');
    if (!isNaN(select)) {
      setBookBirthdayY(select)
    }
  }
  const changeDate_m = (data) => {
    const selectedValue = data.target.value;
    setBookBirthdayM(selectedValue)
  }
  const changeDate_d = (data) => {
    const selectedValue = data.target.value;
    setBookBirthdayD(selectedValue)
  }

  const changeCheckGender = (event) => {
    const target = event.target.value;
    setBookGender(target)
  }
  const changeSelectTalk = (event) => {
    const target = event.target.value;
    setBookTalk(target)
  }
  const changeTalktext = (event) => {
    const target = event.target.value;
    setBookTalktext(target)
  }
  const changeCheckConect = (event) => {
    const target = event.target.value;
    setBookConectMeans(target)
  }
  const changeDate_before_Time = (event) => {
    const selectedValue = event.target.value;
    setCustomerBeforeTime(selectedValue)
    if (Number(selectedValue) >= Number(bookCustomerAfterTime) || selectedValue === '') {
      setCustomerAfterTime('')
    }

  }
  const changeDate_after_Time = (event) => {
    const selectedValue = event.target.value;
    setCustomerAfterTime(selectedValue)
  }

  //登録ボタンを押せるかどうか
  const submitdisabled = () => {
    if (
      bookArea === null ||
      bookArea === "" ||
      bookShop === null ||
      bookShop === "" ||
      bookData === null ||
      bookData === "" ||
      bookCategory === null ||
      bookCategory === "" ||
      bookTime === null ||
      bookTime === "" ||
      bookName === null ||
      bookName === "" ||
      bookKana === null ||
      bookKana === "" ||
      !(((bookBirthdayY === null || bookBirthdayY === "") &&
        (bookBirthdayM === null || bookBirthdayM === "") &&
        (bookBirthdayD === null || bookBirthdayD === "")) ||
        (!(bookBirthdayY === null || bookBirthdayY === "") &&
          !(bookBirthdayM === null || bookBirthdayM === "") &&
          !(bookBirthdayD === null || bookBirthdayD === ""))) ||
      !Common.dateValidation(
        (bookBirthdayY && bookBirthdayM && bookBirthdayD ? bookBirthdayY + bookBirthdayM + bookBirthdayD : ''), 
        true) ||
      bookTalk === null ||
      bookTalk === "" ||
      (!(bookCustomerBeforeTime === null || bookCustomerBeforeTime === "") && (bookCustomerAfterTime === null || bookCustomerAfterTime === "")) ||
      isSubmitting === true
    ) {
      return true
    } else { return false }
  }

  // 予約便の確認 true:有効
  const checkBookingValid = async () => {
    //トークンを取得
    const jwt = localStorage.getItem('jwt');
    const params = {
      "operator": "and",
      "where": [
        { "site_id": props.siteId },
        { "book_date": bookData },
        { "category_id": bookCategory },
        { "shop_id": bookShop }
      ]
    }
    const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/search/`, params, { headers: { Authorization: `Bearer ${jwt}` } })).data;

    const selectedTime = (bookTimeList ?? []).find(item => Number(bookTime) === Number(item.book_set_id) && item.book_date === bookData && Number(item.shop_id) === Number(bookShop));
    if (!selectedTime) {
      console.warn('bookTimeListに対象の予約便が見つからないため、予約を中断します。', { bookTime, bookData, bookShop, bookCategory });
      return true;
    }
    const count = Number(selectedTime.book_count ?? 0);
    var setcount = 0;

    //予約承認済と仮予約の値を数える
    data.forEach(d => {
      if (Number(d.book_set_id) === Number(bookTime) && (d.t_booking?.status === "REG" || d.t_booking?.status === "TREG" || d.t_booking?.status === "FIN")) {
        setcount = setcount + 1;
      }
    })

    //予約内容を変更している場合は、元の予約内容はカウントから外す
    if (booking?.book_date === bookData && booking?.t_booking_detail?.category_id === bookCategory && booking?.t_booking_detail?.shop_id === bookShop && Number(booking?.t_booking_detail?.book_set_id) === Number(bookTime)) {
      setcount = setcount - 1;
    }

    if (setcount >= count) {
      return true;
    } else {
      return false;
    }
  }

  const submit = async () => {
    setIsSubmitting(true);
    try {
      if (await checkBookingValid()) {
        alert('指定数の予約が取れません。時間帯または予約数の変更をお願いします。');
        return false;
      }

      if (!window.confirm('登録しますか？')) {
        return;
      }

      //データベースに登録する
      const detail = [{
        site_id: props.siteId,
        book_id: bookId ? bookId : null,
        book_set_id: bookSetId ? bookSetId : null,
        category_id: Number(bookCategory),
        book_date: bookData,
        start_time: bookStartTime,
        end_time: bookEndTime,
        price_before_tax: 0,
        price: 0,
        tax_rate: 0,
        count: 1,
        remarks: remarks ? remarks : "",
        total: 0,
      }]
      var data = {
        // bookIdがnullかどうかで値を引き継ぐか決める
        card_id: bookCardId ? bookCardId : null,
        site_id: props.siteId,
        book_id: bookId ? bookId : null,
        book_date: bookData ? new Date(bookData) : null,
        customer_id: bookId ? customer.customer_id : null,
        receipt_num: bookId ? customer.receipt_num : null,
        receipt_datetime: bookId ? customer.receipt_datetime : null,
        customer_name: bookName,
        customer_kana: bookKana,
        customer_address_number: bookAddressNumber,
        customer_address1: bookAddress1,
        customer_address2: bookAddress2,
        customer_address3: bookAddress3,
        customer_phone: bookPhone ? bookPhone : null,
        customer_mobilephone: bookMobilePhone ? bookMobilePhone : null,
        birthdayY: bookBirthdayY,
        birthdayM: bookBirthdayM,
        birthdayD: bookBirthdayD,
        talk_id: bookTalk ? bookTalk : null,

        talktext: bookTalktext ? bookTalktext : "",

        shop_id: String(bookShop),
        connect_means: (bookConectMeans) ? bookConectMeans : null,
        customer_before_Time: (bookCustomerBeforeTime) ? bookCustomerBeforeTime : null,
        customer_after_Time: (bookCustomerAfterTime) ? bookCustomerAfterTime : null,
        staff_name: bookStaff ? bookStaff : null,

        customer_gender: bookGender ? bookGender : null,
        privacy_policy: constClass.FLAG.ON,

        //idではなくトークンを入れる
        line_id: customer?.line_id ? customer.line_id : null,
        subtotal: 0, discount: 0, tax: 0,
        total: 0,
        before_total: null,
        payment_fin_flag: constClass.FLAG.OFF,
        status: booking?.status ? booking.status : constClass.STATUS.TREG, //初期ステータスはTREG、ステータスがある場合は引き継ぐ
        t_booking_detail: detail,
        before_booking_detail: booking?.t_booking_detail
          ? [booking.t_booking_detail]
          : [],
      }

      var result = null;//DB登録の結果取得
      var book_farst = bookId ? false : true;
      const jwt = localStorage.getItem('jwt');
      if (bookId) {//予約一覧から来たかどうかを判定する
        result = (await axios.put(`${process.env.REACT_APP_BACKEND_URL}/booking/backyard/${bookId}`, data, { headers: { Authorization: `Bearer ${jwt}` } }));
      } else {
        result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/backyard/`, data, { headers: { Authorization: `Bearer ${jwt}` } }));
      }
      // ログを送信する
      const send_params = {
        site_id: props.siteId,
        user_id: props.user.userId,
        text: "受付番号: " + result.data.book.book_id + " 予約内容が変更されました",
        book_id: result.data.book.book_id,
        shop_id: props.user.shopId,
        book_farst: book_farst,
        old_status: booking?.status ? booking.status : null,
      }
      //メッセージを送信
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/log/send`, send_params, { headers: { Authorization: `Bearer ${jwt}` } });


      if (result.data && result.data.result) {
        //成功したことを伝える
        alert('登録が完了しました');
      } else {
        //err
        console.log(util.inspect(result))
        alert('登録に失敗しました。1');
      }

      //ボタン連打によって二重で値を登録したりしないように念のため値を初期化する
      reset();

    } catch (e) {
      console.log("エラー", e)
      alert('登録に失敗しました。2');
    } finally {
      setIsSubmitting(false);
    }
  }

  useEffect(() => {
    refreshBook();
  }, [refreshBook]);

  //表示に最低限必要な変数はここで管理する
  const vew = () => {
    if (arealist && shoplist && talklist && bookDateList && categoryMaster && bookTimeList) {
      return true
    } else { return false }
  }
  return (vew() &&
    <div className="row mx-3 my-3 px-0-env">
      <div className="col bg-white px-0 mb-3">
        {bookId && <h5 className="col-12 mb-3">予約ID：{bookReceiptNum}</h5>}
        <div className="row  w-75 mx-auto my-3">
          <div className="col-4">
            <div className="border p-2 mb-3 w-100 mx-auto">
              <div>エリア(必須)</div>
              <select className="custom-select text-center border-gray" aria-label="店舗"
                value={bookArea}
                onChange={changeselectarea}
              >
                <option value="" >- 選択 -</option>
                {arealist.map((item, idx) =>
                  <option key={idx} value={item.area_id}>{item.area_name}</option>
                )}
              </select>
              <div>支所(必須)</div>
              <select className="custom-select text-center border-gray" aria-label="店舗"
                value={bookShop}
                onChange={changeSelectShop}
                disabled={(bookArea === null || bookArea === "")}
              >
                <option value="" >- 選択 -</option>
                {shoplist.filter(d => d.area_id === bookArea).map((item, idx) =>
                  <option key={idx} value={item.shop_id}>{item.shop_name}</option>
                )}
              </select>
              <div>ご予約日(必須)</div>
              <select className="custom-select text-center border-gray" aria-label="予約日"
                value={bookData}
                onChange={(e) => changeBookDate(e.target.value)}
              >
                <option value="" >- 選択 -</option>
                {bookDateList.map((item, idx) =>
                  <option key={idx} value={item.book_date}>{moment(item.book_date).format('YYYY/MM/DD')}({moment(item.book_date).format('dd')})</option>
                )}
              </select>
              <div>カテゴリ(必須)</div>
              <select className={`custom-select text-center border-gray`} aria-label="カテゴリ"
                value={bookCategory}
                onChange={(e) => changeCategory(e.target.value)}
              >
                <option value="" >- 選択 -</option>
                {categoryMaster.map((item) =>
                  <option key={item.category_id} value={item.category_id}>{item.category_name}</option>
                )}
              </select>
              <div>予約時間帯(必須)</div>
              <select className={`custom-select text-center border-gray`} aria-label="カテゴリ"
                value={bookTime}
                onChange={(e) => changeDate(e.target.value)}
                disabled={bookArea === null || bookArea === "" || bookShop === null || bookShop === "" || bookData === null || bookData === "" || bookCategory === null || bookCategory === ""}
              >
                <option value="" >- 選択 -</option>
                {bookTimeList.filter(d =>
                  d.book_date === bookData && Number(bookShop) === Number(d.shop_id) && Number(d.category_id) === Number(bookCategory)
                ).map((item, idx) =>
                  <option key={idx} value={item.book_set_id}>{CommonBooking.strTotime(item.start_time)}～{CommonBooking.strTotime(item.end_time)}</option>
                )}
              </select>
              <div>担当職員</div>
              <div className="col px-0">
                <input type="text" className="form-control border-gray" id="bookStaff" name="bookStaff" onChange={e => changeCustomerStaff(e)} value={bookStaff || ''} />
              </div>
            </div>
          </div>

          <div className="col-8">
            <div className="border p-2 mb-3 w-100 mx-auto">
              <div>会員番号</div>
              <div className="col-4 px-0">
                <input type="text" className="form-control border-gray" id="bookCardId" name="bookCardId" onChange={e => changeCustomerCardId(e)} value={bookCardId || ''} inputMode={"numeric"} />
              </div>
              <div className="row mx-0 text-left">
                <div className="col-4 px-0">
                  <div>お名前(必須)</div>
                  <div className="col px-0">
                    <input type="text" className="form-control border-gray" id="bookName" name="bookName" onChange={e => changeCustomerName(e)} value={bookName || ''} />
                  </div>
                </div>
                <div className="col-4 px-1">
                  <div>カナ氏名(必須)</div>
                  <div className="col px-0">
                    <input type="text" className="form-control border-gray" id="bookKana" name="bookKana" onChange={e => changeCustomerKana(e)} value={bookKana || ''} />
                  </div>
                </div>
              </div>

              <div>郵便番号</div>
              <div className='row mx-0 text-left'>
                <div className="px-0"><input type="text" className="form-control border-gray" id="bookAddressNumber" name="bookAddressNumber" onChange={e => changeAddresNumber(e)} value={bookAddressNumber || ''} inputMode={"numeric"} maxLength={7} /></div>
                <div className="px-2"><button className='btn btn-main-active w-100 border bg-secondary text-white border-gray' onClick={() => searchAddress(bookAddressNumber, 'customer_address')}>住所検索</button></div>
              </div>
              <div>住所</div>
              <div className="row mx-0 text-left">
                <div className='col-4 mx-0 px-0'>
                  <select className={`form-control text-left border-gray`} onChange={changeAddress1} value={bookAddress1 || ""}>
                    {setPrefectures()}
                  </select>
                </div>
                <div className="col-4 px-1">
                  <input type="text" className="form-control border-gray" id="bookAddress2" name="bookAddress2" onChange={changeAddress2} value={bookAddress2 || ''} placeholder="例）山口市" />
                </div>
                <div className="col-4 px-0">
                  <input type="text" className="form-control border-gray" id="bookAddress3" name="bookAddress3" onChange={changeAddress3} value={bookAddress3 || ''} />
                </div>
              </div>
              <div className="row mx-0 text-left">
                <div className="col-4 px-0">
                  <div>電話番号</div>
                  <input type="text" className="form-control border-gray" onChange={changePhone} value={bookPhone || ""} placeholder='例)09012345678' inputMode={"numeric"} />
                </div>
                <div className="col-4 px-1">
                  <div>携帯電話番号</div>
                  <input type="text" className="form-control border-gray" onChange={changeMobilephone} value={bookMobilePhone || ""} placeholder='例)09012345678' inputMode={"numeric"} />
                </div>
              </div>
              <div>生年月日</div>
              <div className="row mx-0 text-left">
                <div className='col-auto mx-0 px-1 py-2'>西暦</div>
                <div className='col mx-0 px-0' style={{ maxWidth: "5rem" }}>
                  <input type="text" className={`form-control border-gray`} onChange={changeDate_y} value={bookBirthdayY || ""} inputMode={"numeric"} maxLength={4} />
                </div><div className='col-auto mx-0 px-1 py-2'>年</div>

                <div className='col-auto mx-0 px-0' style={{ maxWidth: "4rem" }}>
                  <select className={`form-control text-center border-gray`} onChange={changeDate_m} value={bookBirthdayM || ""} >
                    {setMonth()}
                  </select>
                </div><div className='col-auto mx-0 px-1 py-2'>月</div>

                <div className='col-auto mx-0 px-0' style={{ maxWidth: "4rem" }}>
                  <select className={`form-control text-center border-gray`} onChange={changeDate_d} value={bookBirthdayD || ""}>
                    {setDay("")}
                  </select>
                </div><div className='col-auto mx-0 px-1 py-2'>日</div>
              </div>
              <div>性別</div>
              <div className="row mx-0 text-left">
                {constClass.CUSTOMER_GENDER.map((customer_gender, idx) => (
                  <div key={idx} className={`col-3 mx-1 px-3-env align-self-center form-control custom-radio ${customer_gender === bookGender ? " border-gray bg-lightyellow" : "border-gray"}`}>
                    <input type="radio" className="custom-control-input" id={`customer_gender_${customer_gender}`} name="customer_gender" onChange={e => changeCheckGender(e)} value={customer_gender} checked={bookGender === customer_gender} />
                    <label className="custom-control-label text-nowrap" htmlFor={`customer_gender_${customer_gender}`}>{constClass.CUSTOMER_GENDER_NAME[customer_gender]}</label>
                  </div>
                ))}
              </div>
              <div>予約の目的(必須)</div>
              {/* 相談内容プルダウン */}
              <select className="custom-select col-8 border-gray text-left" aria-label="相談カテゴリー"
                value={bookTalk || ''}
                onChange={changeSelectTalk}>
                <option value="" >- 選択 -</option>
                {talklist.map((item, idx) =>
                  <option key={idx} value={item.talk_id}>{item.talk}</option>
                )}
              </select>
              <div>目的詳細</div>
              <div className="col px-0 ">
                <textarea className="form-control border-gray" onChange={e => changeTalktext(e)} value={bookTalktext || ''} />
              </div>
              <div className="row mx-0 text-left">
                <div className="col-6 px-0">
                  <div>ご希望の連絡先</div>
                  <div className="row mx-0 text-left">
                    {constClass.CUSTOMER_PHONE.map((customer_phon, idx) => (
                      <div key={idx} className={`col mx-1 px-3-env align-self-center form-control custom-radio ${customer_phon === bookConectMeans ? "border-gray bg-lightyellow" : "border-gray"}`}>
                        <input type="radio" className="custom-control-input" id={`customer_selectphone${customer_phon}`} name="customer_selectphone" onChange={e => changeCheckConect(e)} value={customer_phon} checked={bookConectMeans === customer_phon} />
                        <label className="custom-control-label text-nowrap" htmlFor={`customer_selectphone${customer_phon}`}>{constClass.CUSTOMER_PHONE_NAME[customer_phon]}</label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-6 px-3-env">
                  <div>平日連絡可能時間</div>
                  <div className="row mx-0 text-left">
                    <div className='mx-0 px-0' style={{ maxWidth: "4rem" }}>
                      <select className={`form-control text-center border-gray`} onChange={changeDate_before_Time} value={bookCustomerBeforeTime || ""} >
                        {setTimeBefore()}
                      </select>
                    </div>
                    <div className='col-auto mx-0 px-1 py-2'>時～</div>

                    <div className='mx-0 px-0' style={{ maxWidth: "4rem" }}>
                      <select className={`form-control text-center border-gray`} onChange={changeDate_after_Time} value={bookCustomerAfterTime || ""} disabled={bookCustomerBeforeTime === null || bookCustomerBeforeTime === ""}>
                        {setTimeAfter()}
                      </select>
                    </div>
                    <div className='col-auto mx-0 px-1 py-2'>時</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          disabled={submitdisabled()}
          className={`btn btn-active w-100 py-2`}
          onClick={submit}
        >
          登録
        </button>
      </div>
    </div>
  )
}

export default BookingInput;